module.exports = __webpack_public_path__ + "img/middle_20.5cc2335c.png";